import { Button } from 'primereact/button';
import { FundValuationEvent } from './colDefsFundValuationEventTable';

export const OptionCell = (props: { data: FundValuationEvent }) => {
  const { handleRemove, id: fundValuationId } = props.data;
  return (
    <Button
      label="Remove"
      severity="warning"
      size="small"
      style={{ height: '28px' }}
      onClick={() => handleRemove(fundValuationId)}
    />
  );
};
